// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-footer {
  padding: 16px 24px 20px;
  text-align: center;
  color: rgba(74, 74, 74, 1);
  font-family: "Open Sans", Arial, sans-serif;
  font-size: 13px;
}

.login-footer-no-account {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 60px;
}

.login-footer-nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.login-footer-terms {
  margin: 0;
  line-height: 1.4;
}

.login-footer-link {
  color: rgba(222, 72, 88, 1);
  text-decoration: none;
}

.login-footer-nav .login-footer-link {
  color: rgba(74, 74, 74, 1);
  font-size: 14px;
  font-weight: 600;
}

.login-footer-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/LoginFooter.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".login-footer {\n  padding: 16px 24px 20px;\n  text-align: center;\n  color: rgba(74, 74, 74, 1);\n  font-family: \"Open Sans\", Arial, sans-serif;\n  font-size: 13px;\n}\n\n.login-footer-no-account {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 60px;\n}\n\n.login-footer-nav {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.login-footer-terms {\n  margin: 0;\n  line-height: 1.4;\n}\n\n.login-footer-link {\n  color: rgba(222, 72, 88, 1);\n  text-decoration: none;\n}\n\n.login-footer-nav .login-footer-link {\n  color: rgba(74, 74, 74, 1);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.login-footer-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
